import React from "react";
import { Loader2, Send, Save, Undo2, CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";

function Act({ id, busy, onClick, icon: Icon, children, variant, className = "rounded-full bg-slate-900 hover:bg-slate-800" }) {
  return (
    <Button disabled={!!busy} onClick={onClick} variant={variant} className={variant ? "rounded-full" : className} data-testid={`notes-${id}-btn`}>
      {busy === id ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <Icon className="mr-2 h-4 w-4" />} {children}
    </Button>
  );
}

// Footer buttons by role and status: stage manager submits; director saves, publishes, returns or approves.
export default function NoteFormActions({ director, note, busy, save, onReturn }) {
  const published = note?.status === "published";
  const reviewing = director && note && note.status !== "draft" && !published;
  return (
    <div className="sticky bottom-0 -mx-6 -mb-6 flex flex-wrap justify-end gap-2 border-t border-slate-200 bg-white/90 px-6 py-3 backdrop-blur" data-testid="notes-form-actions">
      {published && <Act id="save-published" busy={busy} icon={Save} onClick={() => save(false, "save-published")}>Save changes</Act>}
      {!director && (
        <Act id="submit" busy={busy} icon={Send} onClick={() => save(false, "submit")}>{note?.status === "returned" ? "Resubmit for review" : "Submit for review"}</Act>
      )}
      {director && !reviewing && !published && <>
        <Act id="save-draft" busy={busy} icon={Save} variant="outline" onClick={() => save(false, "save-draft")}>Save draft</Act>
        <Act id="publish" busy={busy} icon={Send} onClick={() => save(true, "publish")}>Publish</Act>
      </>}
      {reviewing && <>
        <Act id="save-changes" busy={busy} icon={Save} variant="outline" onClick={() => save(false, "save-changes")}>Save changes</Act>
        {note.status === "pending" && <Act id="return" busy={busy} icon={Undo2} variant="outline" onClick={onReturn}>Return</Act>}
        <Act id="approve" busy={busy} icon={CheckCircle2} className="rounded-full bg-emerald-600 hover:bg-emerald-700" onClick={() => save(true, "approve")}>Approve & publish</Act>
      </>}
    </div>
  );
}
